<div class="row">
  <div class="col-md-12 col-sm-12 col-lg-6" *ngFor="let creditVoucherCard of creditVoucherCards">
    <div class="card lift" style="width: 100%">
      <div class="inner-container">
        <div class="card-image-header show-image" style="background-image: url('{{ creditVoucherCard.headImage }}');">&nbsp;</div>
      </div>

      <div class="card-body">
        <h3 class="card-title">{{ creditVoucherCard.title }}</h3>

        <p class="card-text" [innerHTML]="creditVoucherCard.body | mdToHtml"></p>

        <div class="button-center">
          <a class="ba-btn" href="{{ creditVoucherCard.url }}">{{ creditVoucherCard.buttonText }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
